import { isPersonalNumberValid } from "Shared/Utils/validations";

export const removeSpaces = (value: string) => {
  return value.replace(/\s/g, "");
};

export const personalIdentificationNumberToDate = (identityNumber: string) => {
  if (!isPersonalNumberValid(identityNumber)) return null;

  const value = identityNumber.replace(/\D/g, "");

  const actualYear = new Date().getFullYear();

  let yearS = Number.parseInt(value.substring(0, 2), 10);

  if (yearS + 2000 <= actualYear) {
    if (identityNumber.length === 9) {
      yearS = 1900 + yearS;
    } else {
      yearS = 2000 + yearS;
    }
  }
  let monthS = Number.parseInt(value.substring(2, 4), 10) - 1;
  const dayS = Number.parseInt(value.substring(4, 6), 10);

  if (monthS >= 50) monthS = monthS - 50;

  return new Date(yearS, monthS, dayS);
};

export const clearInputMaskSeparator = (val: string | null | undefined) => {
  let value = val;
  if (value) {
    if (typeof value === "string" && value.indexOf("_") !== -1)
      value = value.replace(/_/g, "");
  }
  return value;
};
